function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.71 65.42a32.71 32.71 0 1132.71-32.71 32.74 32.74 0 01-32.71 32.71zm0-59.42a26.71 26.71 0 1026.71 26.71A26.63 26.63 0 0032.71 6z",
  fill: "#dce1ec"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.62 47a3 3 0 01-3-3V21.52a3 3 0 014.52-2.58l19.13 11.25a3 3 0 010 5.17L28.14 46.61a2.94 2.94 0 01-1.52.39zm3-20.25v12l10.21-6z",
  fill: "#23c386"
})));

function SvgResourceWatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.42 65.42"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NS40MiA2NS40MiI+PGcgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoIGQ9Ik0zMi43MSA2NS40MmEzMi43MSAzMi43MSAwIDExMzIuNzEtMzIuNzEgMzIuNzQgMzIuNzQgMCAwMS0zMi43MSAzMi43MXptMC01OS40MmEyNi43MSAyNi43MSAwIDEwMjYuNzEgMjYuNzFBMjYuNjMgMjYuNjMgMCAwMDMyLjcxIDZ6IiBmaWxsPSIjZGNlMWVjIi8+PHBhdGggZD0iTTI2LjYyIDQ3YTMgMyAwIDAxLTMtM1YyMS41MmEzIDMgMCAwMTQuNTItMi41OGwxOS4xMyAxMS4yNWEzIDMgMCAwMTAgNS4xN0wyOC4xNCA0Ni42MWEyLjk0IDIuOTQgMCAwMS0xLjUyLjM5em0zLTIwLjI1djEybDEwLjIxLTZ6IiBmaWxsPSIjMjNjMzg2Ii8+PC9nPjwvZz48L3N2Zz4=";
export { SvgResourceWatch as ReactComponent };